module.exports = __webpack_public_path__ + "img/services-tree-clean.66cc33f1.svg";